import { Injectable, signal, inject } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { ErrorLogService } from '@shared/services/error-log.service'

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  private readonly hideDelay = 10000

  private errorLogService = inject(ErrorLogService)

  #error = signal<string | null>(null)
  error = this.#error.asReadonly()

  handleError(errorResponse: HttpErrorResponse | undefined, context: string = '') {
    let errorMessage = ''
    if (errorResponse) {
      this.errorLogService.log(errorResponse, 'ErrorMessageService', context)

      const status = errorResponse.status
      if (status >= 400 && status < 500) {
        errorMessage =
          errorResponse?.error?.error?.alias ??
          errorResponse?.error?.error?.description ??
          errorResponse?.error?.message ??
          ''
      }
      if (status >= 500 && status <= 600) {
        errorMessage = `The server is not available atm: ${errorResponse.message}`
      }
    }
    this.setError(errorMessage === '' ? null : errorMessage)
    return errorMessage
  }

  showError(error: string) {
    this.setError(error || null)
  }

  setError(message: string | null) {
    this.#error.set(message)
    if (message) {
      setTimeout(() => this.#error.set(null), this.hideDelay)
    }
  }
}
